/* eslint-disable no-unused-vars */
import get from 'lodash/get';
import omit from 'lodash/omit';
import { UPDATE_LIST_SECTION } from '../types';
import {
  getNextQuestionSet,
  getSectionAnswers,
  resetCurrentEditListIndices,
  saveListQuestionResponses,
} from './questions';

export const getAnswersArray = (state, sectionIndex) => {
  const currentBreadcrumbId = get(state, 'questions.activeSubsectionId', '');
  const currentSection = state.questions.sections[currentBreadcrumbId][sectionIndex];
  const pageSeqNumber = get(state, 'questions.currentPageSeqNumber', 1);
  const { completed, answersArray, questionList } = currentSection;
  return {
    completed,
    answersArray,
    questionList,
    pageSeqNumber,
  };
};

export const getListAnswersArray = (state) => {
  const currentBreadcrumbId = get(state, 'questions.activeSubsectionId', '');
  const currentSection = state.questions.sections[currentBreadcrumbId];
  const { questionList: questionTest } = getSectionAnswers(currentSection);
  const questionParams = [];
  questionTest.forEach((question) => {
    if (question.display_type === 'list') {
      questionParams.push({
        question_id: question.question_id,
        answer: [],
        extra_params: {
          list_completed_flag: true,
        },
      });
    } else if (question.display_type === 'questions_group') {
      questionParams.push({
        question_id: question.question_id,
        answer: '',
      });
    }
  });
  return questionParams;
};

export const addListItem = (
  sectionIndex,
  index,
  qIds,
  listId,
  listActionId,
  parentListIndex,
  isNestedQ,
) => {
  return (dispatch, getState) => {
    const state = getState();

    const { uid } = state;

    const { answersArray, questionList, pageSeqNumber } = getAnswersArray(
      state,
      sectionIndex,
      true,
    );

    let outerListExtraParams = {
      list_completed_flag: false,
    };

    let innerListExtraParams = {
      list_completed_flag: false,
    };

    let innerListQuestionParams = [];
    let outerListQuestionParams = [];

    if (isNestedQ) {
      const innerListQs = answersArray.filter(
        (question) => qIds.indexOf(question.question_id) > -1,
      );
      const innerListAnswers = [];
      if (Number.isInteger(index) && index >= 0) {
        innerListExtraParams = {
          ...innerListExtraParams,
          current_list_answer_index: index,
        };
        innerListQs.forEach((q) => {
          const temp = {
            question_id: q.question_id,
            answer: q.answer,
            transaction_log: q.transaction_log,
            num_times_answered: q.num_times_answered,
            lastSubmittedAt: q.lastSubmittedAt,
          };
          innerListAnswers.push(temp);
        });
      } else {
        innerListQs.forEach((q) => {
          const temp = {
            question_id: q.question_id,
            answer: q.answer,
            transaction_log: q.transaction_log,
            num_times_answered: q.num_times_answered,
            lastSubmittedAt: q.lastSubmittedAt,
          };
          innerListAnswers.push(temp);
        });
      }

      innerListQuestionParams = [
        {
          question_id: listId,
          answer: innerListAnswers,
          extra_params: innerListExtraParams,
        },
      ];

      outerListQuestionParams = innerListQuestionParams;

      // now get outer list questions
      const outerListQs = answersArray.filter(
        (question) => qIds.indexOf(question.question_id) === -1,
      );
      const outerListAnswers = [];
      let outerListParentId = null;
      if (outerListQs.length && Number.isInteger(parentListIndex)) {
        outerListQuestionParams = [];
        outerListQs.forEach((q) => {
          if (!outerListParentId) {
            outerListParentId = q.listParentId;
          }
          const temp = {
            question_id: q.question_id,
            answer: q.answer,
            transaction_log: q.transaction_log,
            num_times_answered: q.num_times_answered,
            lastSubmittedAt: q.lastSubmittedAt,
          };
          outerListAnswers.push(temp);
        });
        if (Number.isInteger(parentListIndex)) {
          outerListExtraParams = {
            ...outerListExtraParams,
            current_list_answer_index: parentListIndex,
          };
        }
        outerListAnswers.push(...innerListQuestionParams);
        outerListQuestionParams = [
          {
            question_id: outerListParentId,
            answer: outerListAnswers,
            extra_params: outerListExtraParams,
          },
        ];
      }
    } else {
      const innerListAnswers = [];
      const innerListParentId = null;

      if (innerListAnswers.length) {
        innerListExtraParams = {
          ...innerListExtraParams,
        };

        innerListQuestionParams = [
          {
            question_id: innerListParentId,
            answer: innerListAnswers,
            extra_params: innerListExtraParams,
          },
        ];
      }

      const outerListQs = answersArray.filter(
        (question) => qIds.indexOf(question.question_id) > -1,
      );
      const outerListAnswers = [];
      if (outerListQs.length) {
        outerListQs.forEach((q) => {
          const temp = {
            question_id: q.question_id,
            answer: q.answer,
            transaction_log: q.transaction_log,
            num_times_answered: q.num_times_answered,
            lastSubmittedAt: q.lastSubmittedAt,
          };
          outerListAnswers.push(temp);
        });
      }

      if (Number.isInteger(index) && index >= 0) {
        outerListExtraParams = {
          ...outerListExtraParams,
          current_list_answer_index: index,
        };
      }
      outerListAnswers.push(...innerListQuestionParams);
      outerListQuestionParams = [
        {
          question_id: listId,
          answer: outerListAnswers,
          extra_params: outerListExtraParams,
        },
      ];
    }
    dispatch(resetCurrentEditListIndices());

    const reqParams = {
      uid,
      questions: outerListQuestionParams,
      page_sequence_number: pageSeqNumber,
      index_modify_flag: 1,
      list_question_id: listId,
    };
    dispatch(
      getNextQuestionSet('/questions', reqParams, {
        isReflexive: true,
        sectionIndex,
        questionId: get(questionList[0], 'question_id', ''),
        isList: true,
        listActionId,
        ...reqParams,
      }),
    );
  };
};

export const getNextListItemForm = (
  sectionIndex,
  listId,
  listActionId,
  parentListIndex,
  questionsLength,
) => {
  return (dispatch, getState) => {
    const state = getState();

    const { uid, questions } = state;
    const { currentPageSeqNumber } = questions;
    const sectionIndx = listId.includes('ContingentBeneficiary') ? 1 : sectionIndex;

    const { questionList } = getAnswersArray(state, sectionIndx, true);

    let reqParams = {
      uid,
      page_sequence_number: currentPageSeqNumber,
      index_modify_flag: 1,
      next_page_flag: 1,
      list_question_id: listId,
    };
    const listParams = {
      question_id: listId,
      list_params: [],
      current_list_index: questionsLength - 1,
    };

    if (Number.isInteger(parentListIndex)) {
      const listQ = questionList.filter((q) => q.display_type === 'list')[0];
      const listParentId = listQ.question_id;

      reqParams = {
        list_params: [
          {
            question_id: listParentId,
            list_params: [{ ...listParams }],
            current_list_index: parentListIndex,
          },
        ],
        ...reqParams,
      };
    }
    dispatch(
      getNextQuestionSet('/questions', reqParams, {
        isReflexive: true,
        sectionIndex,
        isListAddAction: true,
        listActionId,
        ...reqParams,
      }),
    );
  };
};

export const submitListAnswers = (sectionIndex, action = '', listId) => {
  return (dispatch, getState) => {
    const state = getState();

    const { uid } = state;

    const { questionList, pageSeqNumber } = getAnswersArray(state, sectionIndex, true);

    // for beneficiaries and contingent beneficiary
    const groupQuestion = questionList.filter(
      (question) => question.display_type === 'questions_group',
    )[0];
    const listQuestion = questionList.filter((question) => question.display_type === 'list')[0];

    let questionParams = [
      {
        question_id: listId || listQuestion.question_id,
        answer: [],
        extra_params: {
          list_completed_flag: true,
        },
      },
      {
        question_id: groupQuestion.question_id,
        answer: '',
      },
    ];

    if (action === 'CONFIRM_UPDATE') {
      questionParams = getListAnswersArray(state);
    }

    const extraParams = action ? { action } : { next_page_flag: 1 };

    let reqParams = {
      uid,
      page_sequence_number: pageSeqNumber,
      questions: questionParams,
      ...extraParams,
    };

    if (action === 'CANCEL_UPDATE') {
      reqParams = {
        uid,
        page_sequence_number: pageSeqNumber,
        ...extraParams,
      };
    }

    dispatch(
      getNextQuestionSet('/questions', reqParams, {
        sectionIndex,
        sectionId: get(questionList[0], 'question_id', ''),
        ...reqParams,
      }),
    );
  };
};

export const listSectionUpdates = (sectionIndex, listIndex, listQIds, listId, listActionId) => {
  return (dispatch, getState) => {
    const state = getState();
    const { uid } = state;
    const activeSubsectionId = get(state, 'questions.activeSubsectionId', '');
    dispatch({
      type: UPDATE_LIST_SECTION,
      activeSubsectionId,
      payload: {
        sectionIndex,
        listQIds,
      },
    });
    const { pageSeqNumber } = getAnswersArray(state, sectionIndex, true);
    const reqParams = {
      uid,
      page_sequence_number: pageSeqNumber,
      index_cancel_flag: 1,
      list_question_id: listId,
      current_list_answer_index: listIndex,
    };
    dispatch(
      getNextQuestionSet('/questions', reqParams, {
        isReflexive: true,
        sectionIndex,
        isList: true,
        listActionId,
        ...reqParams,
      }),
    );
  };
};

export const deleteBeneficiary = (index, sectionIndex, listId, listActionId, parentListIndex) => {
  return (dispatch, getState) => {
    const state = getState();

    const { uid } = state;
    const sectionIndx = listId.includes('ContingentBeneficiary') ? 1 : sectionIndex;

    const { questionList, pageSeqNumber } = getAnswersArray(state, sectionIndx, true);

    // for beneficiaries and contingent beneficiary
    const listQuestion = questionList.filter((question) => question.display_type === 'list')[0];
    const groupQuestion = questionList.filter(
      (question) => question.display_type === 'questions_group',
    )[0];

    const questionParams = [
      {
        question_id: listId || listQuestion.question_id,
        answer: [],
        extra_params: {
          list_completed_flag: false,
          ...(index !== undefined
            ? { current_list_answer_index: index }
            : { clear_original_question: true }),
        },
      },
      {
        question_id: groupQuestion.question_id,
        answer: '',
      },
    ];

    let nestedParams = null;
    if (Number.isInteger(parentListIndex)) {
      nestedParams = [
        {
          question_id: listQuestion.question_id,
          answer: [
            {
              question_id: listId || listQuestion.question_id,
              answer: [],
              extra_params: {
                list_completed_flag: false,
                current_list_answer_index: index,
              },
            },
          ],
          extra_params: {
            list_completed_flag: false,
            current_list_answer_index: parentListIndex,
          },
        },
      ];
    }

    const params = Number.isInteger(parentListIndex) ? nestedParams : questionParams;

    const reqParams = {
      uid,
      page_sequence_number: pageSeqNumber,
      delete_index_flag: 1,
      questions: params,
    };

    dispatch(getNextQuestionSet('/questions', reqParams, { isReflexive: true, listActionId }));
  };
};

export const setListIndex = (index) => ({
  type: 'SET_LIST_INDEX',
  index,
});

export const setReflexiveListIndex = (index, id) => ({
  type: 'SET_REFLEXIVE_LIST_INDEX',
  index,
  id,
});

export const closeAddListForm = (sectionIndex, listId, listActionId) => {
  return (dispatch, getState) => {
    const state = getState();
    const { uid } = state;
    const reqParams = {
      uid,
      list_question_id: listId,
    };
    // adding isReflexive as we need to override the redux data to new questions
    dispatch(
      getNextQuestionSet('/questions', reqParams, {
        sectionIndex,
        isReflexive: true,
        listActionId,
      }),
    );
  };
};
